import { MedienGalerie } from '@pilot-hub/ui/components/medien/index'

/** Seite „Medien“: Fotogalerie je Einsatz (auch abgeschlossene), Karte, Download und ZIP – Komponente liegt in packages/ui. */
export function MedienPage() {
  return <MedienGalerie />
}
